import { HookOutOfContextError } from "@jugl-web/utils";
import { useContext } from "react";
import { AgentAnalyticsContext } from "./AgentAnalyticsContext";

export const useAgentAnalyticsContext = () => {
  const context = useContext(AgentAnalyticsContext);

  if (!context) {
    throw new HookOutOfContextError(
      "useAgentAnalyticsContext",
      "AgentAnalyticsContext"
    );
  }

  return context;
};
